import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, Magazzini, MagazziniIdsParentChilds } from '../../models/-index';
import { Observable, take } from 'rxjs';

@Injectable()
export class MagazziniService extends CrudGenericsService<Magazzini, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Magazzini`);
    this.base = `${env.apiUrl}/api/Magazzini/`;
  }

  MagazziniGetIdsParentChilds(model: MagazziniIdsParentChilds): Observable<MagazziniIdsParentChilds> {
    const u = `${this.base}MagazziniGetIdsParentChilds`;
    return this.http.post<MagazziniIdsParentChilds>(u, model).pipe(take(1));
  }
}
